'use strict';

export default class UpdatedCountController {

  /*@ngInject*/
  constructor($http, $stateParams, $state) {
    this.$http = $http;
    this.$stateParams = $stateParams;
    this.$state = $state;
  }

  $onInit() {
    this.getCount()
  }

  getCount(type) {
    this.$http.get('/api/firmware/countFirmwareVersion').then(res => {
      for (const item of res.data) {
        if (item._id === 1) {
          this.versionsDownload = item;   
        } else if (item._id === 2) {
          this.versionsCurrent = item;   
        }
      }
    });
  }

}



// WEBPACK FOOTER //
// ./client/app/firmwares/count/count.controller.js